import { IFWalletRateReq } from '@/api/apiReq/IFWalletReq';
import { useGetWalletRateConfig, useWalletAll, useWalletExchange } from '@/store/walletStore';
import React, { useEffect, useRef, useState } from 'react'
import FormUI from '@/componentsUI/Form';
import { feedback } from '@/utils/feedback';
import FromItemPlus from '@/components/FormItemPlus/FromItemPlus';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import ExchangeTransfer from './compoments/ExchangeTransfer';
import { IFInitWalletRsp } from '@/api/apiRsp/IFWalletRsp';
import { ArrowFallIcon } from '@/componentsUI/Icon';
import './style/index.less'
import ButtonUI from '@/componentsUI/Button';
import SpinUI from '@/componentsUI/Spin';
import { AmountMultiplierConversion, numberTimes, dealAmount9Valid, AmountDivisorConversion } from '@/Core/utils/currencyDealCenter';
import { useCurrency } from '@/hooks/useCurrency';
import { formatCurrencyType } from '@/features/common/currencyDisplay/CurrencyDisplay';

const CurrencyExchange = () => {

    const { t } = useTranslationPlus();
    const currency = useCurrency();
    const { data: wallet, isValidating: walletIsValidating } = useWalletAll()
    const { flat , platform } = wallet || {}
    const [params, setParms] = useState<IFWalletRateReq>()
    const { data, isValidating, error } = useGetWalletRateConfig(params)
    const { trigger, isMutating } = useWalletExchange(); //提交兑换
    const [form] = FormUI.useForm();
    const formValidateRef = useRef(null)

    useEffect(() => {
        if (wallet.all) {
            setParms({
                baseCurrency: platform?.[0]?.serverCurrencyType || platform?.[0]?.currencyType,
                targetCurrency: flat?.[0]?.serverCurrencyType || flat?.[0]?.currencyType,
            })
            form.setFieldValue('out', {
                select: platform?.[0]?.currencyType
            })
            form.setFieldValue('in', {
                select: flat?.[0]?.currencyType
            })
        }
    }, [wallet,flat,platform])

    function onOutValueChange(v) {
        if (!v) {
            const currentIn = form.getFieldValue('in');
            form.setFieldValue('in', {
                ...currentIn,
                amount: v
            })
        } else {
            const currentIn = form.getFieldValue('in');
            const amount = v * Number(data.rate);
            form.setFieldValue('in', {
                ...currentIn,
                amount: numberTimes(Number(amount), Number(data.rate), 9)
            })
        }
    }

    function onSelectOut(selectedWallet: IFInitWalletRsp) {
        const currentIn = form.getFieldValue('in');
        const targetWallet = wallet?.all?.find((w) => w.currencyType === currentIn.select);
        setParms({
            baseCurrency: selectedWallet?.serverCurrencyType || selectedWallet?.currencyType,
            targetCurrency: targetWallet?.serverCurrencyType || currentIn.select,
        })
    }
    function onSelectIn(selectedWallet: IFInitWalletRsp) {
        const currentOut = form.getFieldValue('out');
        const sourceWallet = wallet?.all?.find((w) => w.currencyType === currentOut.select);
        setParms({
            baseCurrency: sourceWallet?.serverCurrencyType || currentOut.select,
            targetCurrency: selectedWallet?.serverCurrencyType || selectedWallet?.currencyType,
        })
    }
    function onConfimSwap() {
        formValidateRef.current = true;
        form.validate().then((v) => {

            // 找到源钱包和目标钱包
            const sourceWallet = wallet.all.find((w)=>{
                if(w.currencyType === v.out?.select) {
                    return w;
                }
            })
            const targetWallet = wallet.all.find((w)=>{
                if(w.currencyType === v.in?.select) {
                    return w;
                }
            })

            if(AmountDivisorConversion(sourceWallet?.allBalance,{
                currencyType: sourceWallet?.currencyType,
                serverCurrencyType: sourceWallet?.serverCurrencyType
            }) < parseFloat(v?.out?.amount)) {
                feedback.error(t('GameOriginal.InsufficientBalance'))
                return
            }

            // 向服务器发送实际的服务端货币类型（BRL），而不是显示用的本地货币
            trigger({
                sourceCurrencyType: sourceWallet?.serverCurrencyType || v?.out?.select,
                sourceMoney: AmountMultiplierConversion(v?.out?.amount, {
                    currencyType: sourceWallet?.currencyType,
                    serverCurrencyType: sourceWallet?.serverCurrencyType
                }),
                targetCurrencyType: targetWallet?.serverCurrencyType || v?.in?.select,
                targetMoney: AmountMultiplierConversion(v?.in?.amount, {
                    currencyType: targetWallet?.currencyType,
                    serverCurrencyType: targetWallet?.serverCurrencyType
                })
            }).catch((e) => {
                if (e.code == 'ERROR_50111') {
                    if (e?.data?.withdrawAmount == 0) {
                        feedback.error(
                            t('EXCHANGE_NEED_BET', {
                                betCode: dealAmount9Valid(e?.data?.betTarget, {
                                    currencyType: e?.data?.currency,
                                }),
                                currency,
                            })
                        );
                    } else {
                        feedback.error(
                            t('EXCHANGE_ALREADY_BET', {
                                alreadyCode: dealAmount9Valid(e?.data?.withdrawAmount, {
                                    currencyType: e?.data?.currency,
                                }),
                                currency,
                            })
                        );
                    }
                }else {
                    feedback.error(t(e.code))
                }
            })
        }).finally(() => {
            formValidateRef.current = false;
        });
    }

    function onClickSwap() {
        // if (isValidating || walletIsValidating || isMutating) {
        //     return
        // }
        // const currentOut = form.getFieldValue('out');
        // const currentIn = form.getFieldValue('in');
        // form.setFieldValue('out', {
        //     amount: undefined,
        //     select: currentIn.select
        // })
        // form.setFieldValue('in', {
        //     amount: undefined,
        //     select: currentOut.select
        // })
        // setParms({
        //     baseCurrency: currentIn.select,
        //     targetCurrency: currentOut.select,
        // })
    }

    const validatorAmount = (values, cb) => {
        if (!formValidateRef.current) {
            return
        }
        if (!values?.amount) {
            return cb(t('Wallet.Wrong Amount'));
        }
        return;
    };

    //刷新汇率
    function refreshRate() {
        const currentOut = form.getFieldValue('out');
        const currentIn = form.getFieldValue('in');
        return `1 ${formatCurrencyType(currentOut.select)}  ≈ ${data.rate} ${currency}`
        // return `1 ${currentOut.select}  ≈ ${data.rate} ${currentIn.select}`
    }

    return (
        <div className='wallet-currency-exchange'>
            {/* {JSON.stringify(data)} */}
            <FormUI
                disabled={isValidating || walletIsValidating || isMutating}
                form={form}
                layout={'vertical'}
                autoComplete={'off'}
            >
                <FromItemPlus
                    field={'out'}
                    label={t('Wallet.ExchangeTransferOut')}
                    required={true} rules={[{ type: 'number' }, { validator: validatorAmount }]}
                >
                    <ExchangeTransfer
                        wallets={platform}
                        onChangeSelect={onSelectOut}
                        onValueChange={onOutValueChange}
                        showBtnMax={true}
                    />
                </FromItemPlus>
                <FromItemPlus>
                    <div className='icon-swap' onClick={onClickSwap}>
                        <ArrowFallIcon />
                    </div>
                </FromItemPlus>
                <FromItemPlus
                    field={'in'}
                    label={t('Wallet.ExchangeTransferIn')}
                >
                    <ExchangeTransfer
                        disabled={true}
                        wallets={flat}
                        onChangeSelect={onSelectIn}
                    />
                </FromItemPlus>

                <div>
                    <div className='rate' aria-busy={(!data && !error) || undefined} aria-live='polite'>
                        {data ? <span>{refreshRate()}</span> : !error && <SpinUI className='rate-loading' dot loading={true} />}
                        {error && <span>{t(error?.code)}</span>}
                    </div>
                    <ButtonUI
                        className={`currency-exchange-btn`}
                        type="primary"
                        disabled={isValidating || walletIsValidating || isMutating}
                        loading={isValidating || walletIsValidating || isMutating}
                        onClick={onConfimSwap}
                    >
                        <span> {t('Wallet.Swap')}</span>
                    </ButtonUI>
                </div>
            </FormUI>
        </div>

    )
}

export default CurrencyExchange
